import * as React from 'react';
import { Paragraph } from '../../../../../elements';
const OtherMeritsRow = ({ value, i18n }) => (React.createElement(React.Fragment, null,
    value.merits.length > 0 || value.comment !== '' ?
        value.merits.map((item, index) => (React.createElement(React.Fragment, { key: index },
            React.createElement(Paragraph, { className: "HeadingSpace", bold: true }, i18n('checkpoint.otherMerits.accordingToResume')),
            React.createElement(Paragraph, null, item.description),
            React.createElement(Paragraph, { className: "HeadingSpace", bold: true }, i18n('checkpoint.otherMerits.accordingToVerification')),
            React.createElement(Paragraph, null, item.accordingToVerification),
            value.merits.length > index + 1 && (React.createElement("hr", { className: "ReadReport__separator" }))))) :
        React.createElement(Paragraph, null, i18n('common.noOtherMerits')),
    value.comment != '' && (React.createElement("div", { className: 'ReadReportContent__Notation ReadReportContent__Space--large' },
        React.createElement(Paragraph, { bold: true }, i18n('common.note')),
        React.createElement("div", { className: 'ReadReportContent__NotationContent' },
            React.createElement(Paragraph, { className: 'ReadReportContent__Space--semi-medium ReadReportContent__Space--scroll-overflow' }, value.comment))))));
export default OtherMeritsRow;
